import { render } from "./Vaticano.vue?vue&type=template&id=947e5b48"
import script from "./Vaticano.vue?vue&type=script&lang=js"
export * from "./Vaticano.vue?vue&type=script&lang=js"

import "./Vaticano.vue?vue&type=style&index=0&id=947e5b48&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__